import { DealerID } from "./Dealer";
import { DBBLeaseCompanyID } from "./LeaseCompany";

export type DBBStorageLocationID = number;

export interface DBBStorageLocation {
  created_on: string;
  updated_on: string;
  id: DBBStorageLocationID; // Claire DBB Storage Location ID
  name: string; // Storage location name
  sub_location_name: string | null; // Storage sub-location name
  dbb_token: string; // DBB token identifying this storage location
  lease_company_id: DBBLeaseCompanyID | null; // Lease company this storage location belongs to, if any
  dealer_id: DealerID; // Dealer this storage location belongs to
}

export interface DBBStorageLocationSummary {
  id: DBBStorageLocationID; // Storage location ID
  name: string; // Storage location name
  sub_location_name: string | null; // Storage sub-location name
}
